import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { casesList } from '@/mocks/cases';

export default function CasesPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative h-[420px] md:h-[540px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20minimalist%20corporate%20technology%20background%2C%20clean%20flowing%20data%20streams%20and%20geometric%20network%20lines%2C%20deep%20dark%20charcoal%20background%20with%20subtle%20warm%20amber%20accent%20tones%2C%20professional%20and%20restrained%2C%20no%20glowing%20particles%20no%20neon%2C%20wide%20banner%20composition&width=1600&height=700&seq=cases-hero&orientation=landscape"
            alt="应用案例"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent" />
          <div className="relative h-full flex flex-col justify-center px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto">
            <nav className="mb-6 flex items-center gap-2 text-sm text-white/70">
              <Link to="/" className="hover:text-white transition-colors">
                首页
              </Link>
              <i className="ri-arrow-right-s-line" />
              <span className="text-white font-medium">应用案例</span>
            </nav>
            <h1 className="text-3xl md:text-5xl font-black text-white font-heading tracking-wide">
              应用案例
            </h1>
            <p className="mt-3 text-base md:text-lg text-white/70 font-label">
              CLASSIC CASES
            </p>
          </div>
        </section>

        {/* Cases List */}
        <section className="py-16 md:py-24 bg-background-50">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto">
            <div className="text-center mb-12 md:mb-16">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
                客户案例
              </h2>
              <div className="mt-4 mx-auto w-12 h-0.5 bg-primary-500 rounded-full" />
              <p className="mt-4 text-sm text-foreground-300 max-w-2xl mx-auto">
                析莜科技携手行业头部企业，以软硬件一体化方案助力企业业务管理的数字化转型升级
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
              {casesList.map((item) => (
                <Link
                  key={item.slug}
                  to={`/cases/${item.slug}`}
                  className="group relative flex flex-col rounded-lg bg-background-50 border border-background-200/50 hover:border-primary-500/40 transition-all duration-300 overflow-hidden"
                >
                  {/* Image */}
                  <div className="relative aspect-[16/9] overflow-hidden">
                    <img
                      src={item.cardImage}
                      alt={item.company}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                    <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                      <span className="inline-block px-3 py-1 rounded-full bg-primary-500/90 text-white text-xs font-medium mb-2">
                        {item.industry}
                      </span>
                      <h3 className="text-xl md:text-2xl font-bold text-white font-heading">
                        {item.company}
                      </h3>
                      <p className="mt-1 text-sm text-white/70 font-label">
                        {item.shortName}
                      </p>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-5 md:p-6 flex-1 flex flex-col">
                    <div className="flex items-center gap-2 text-sm text-primary-500 font-medium mb-3">
                      <i className="ri-folder-chart-line" />
                      {item.project}
                    </div>
                    <p className="text-sm text-foreground-300 leading-relaxed mb-5 flex-1">
                      {item.summary}
                    </p>
                    <div className="flex items-center justify-between pt-4 border-t border-background-200/50">
                      <span className="text-xs text-foreground-400">
                        查看详情
                      </span>
                      <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all">
                        <i className="ri-arrow-right-line" />
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 md:py-20 bg-background-100">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
              期待与您合作
            </h2>
            <p className="mt-4 text-sm text-foreground-300 max-w-xl mx-auto">
              无论您的企业规模如何，析莜科技都能为您提供量身定制的业务管理解决方案。
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/product-center"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors"
              >
                <i className="ri-apps-line" />
                了解产品中心
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-200/50 text-foreground-200 text-sm font-medium hover:bg-background-100 transition-colors"
              >
                <i className="ri-building-line" />
                关于析莜科技
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}